import { render, staticRenderFns } from "./PayGoods.vue?vue&type=template&id=0e05e423&scoped=true&"
import script from "./PayGoods.vue?vue&type=script&lang=js&"
export * from "./PayGoods.vue?vue&type=script&lang=js&"
import style0 from "./PayGoods.vue?vue&type=style&index=0&id=0e05e423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e05e423",
  null
  
)

export default component.exports